export default __webpack_public_path__ + "assets/menu-close_dark.4b94f6fa.svg";